import { type BaseTemplateProps } from '../NotificationTemplate'
import { type TemplateDefinition } from '../TemplateRegistry'

interface PartnerDocsUpdateProps extends BaseTemplateProps {
  // Add any dynamic fields here
}

export const PartnerDocsUpdate: TemplateDefinition<PartnerDocsUpdateProps> = {
  renderParams: (props: PartnerDocsUpdateProps) => ({
    messageKey: 'notificationsDomain.templates.partnerDocsUpdate',
    values: {},
  }),
  getLink: (data: PartnerDocsUpdateProps): string => 'https://partner-docs.instacart.com/',
}
